import { getDataConfigsCountry, getFiltersTranslationPath } from './constants';

/* eslint-disable no-template-curly-in-string */
const FILTER_CONFIGS_SG = (isBuyNewPage?: boolean) => ({
  loading: false,
  initialFilterSettings: [
    {
      name: 'brand_new',
      active: false,
      activeMobile: false,
      algoliaFetching: false,
      isBooleanFilter: true,
      header: getFiltersTranslationPath('brand_new'),
      filterSelectedHeader: getFiltersTranslationPath('brand_new'),
      filters: [
        {
          header: getFiltersTranslationPath('brand_new'),
          name: 'inventory.type',
          type: 'boolean',
          isNumeric: false,
          selectedBoolean: null,
        },
      ],
    },
    {
      name: 'promotions',
      active: true,
      activeMobile: true,
      algoliaFetching: true,
      requireDefaults: true,
      filters: [
        {
          name: 'promotion.title_html.${lang}',
          customName: 'promotion.title_html.${lang}',
          type: 'button',
          filterSelectedHeader: '[label]',
          selectedOptions: null,
        },
      ],
    },
    {
      name: 'tags',
      active: true,
      activeMobile: true,
      algoliaFetching: false,
      header: getFiltersTranslationPath('carroExclusives'),
      headerMobile: getFiltersTranslationPath('carroExclusives'),
      filters: [
        {
          name: 'listing',
          header: getFiltersTranslationPath('exclusives'),
          headerMobile: getFiltersTranslationPath('exclusives'),
          type: 'button',
          filterSelectedHeader: '[label]',
          isNumeric: false,
          isTrueOption: true,
          options: getDataConfigsCountry({
            countryCode: 'sg',
            dataName: 'TAGS',
            listFields: [
              'listing.is_ccpo',
              'listing.is_agent_warranty.sg',
              'listing.is_360',
              'listing.mechanic_video',
              'listing.is_cpa',
            ],
          }),
          selectedOptions: null,
          colSize: 12,
        },
      ],
    },
  ],
  attributesToRetrieve: [
    'id',
    'created_at',
    'promo_label',
    'promo_images',
    'promotion',
    'promotion.promo_blurb.url',
    // 'promotion.title_html.zh-SG',
    'hits',
    'categories',
    'is_promo',
    'listing.title',
    'listing.slug',
    'listing.mileage',
    'listing.asking_price',
    'listing.photos',
    'listing.current_depreciation',
    'listing.depreciation_display_value',
    'listing.installment',
    'listing.is_coming_soon',
    'listing.is_pending_sale',
    'listing.is_sold',
    'listing.is_agent_serviced',
    'listing.is_agent_warranty',
    'listing.is_carro_anywhere',
    'listing.is_available',
    'listing.is_ccpo',
    'listing.is_cpa',
    'listing.is_new_arrival',
    'listing.thumbnail',
    'listing.promotional_price',
    'listing.key_words',
    'listing.months_left',
    'listing.paper_value',
    'listing.status',
    'listing.is_carro_assure',
    'listing.is_carro_assure_plus',
    'listing.agent_warranty',
    'listing.maximum_loan_percentage',
    'listing.downpayment_percentage',
    'listing.original_price',
    'listing.scrap_value',
    'listing.paper_value',
    'listing.downpayment',
    'inventory.id',
    'inventory.original_registration_date',
    'inventory.number_of_owners',
    'inventory.year_of_manufacture',
    'inventory.make',
    'inventory.model',
    'inventory.coe_expiry_date',
    'inventory.car_type',
    'inventory.first_registration_year',
    'inventory.transmission',
    'inventory.fuel_type',
    'inventory.color',
    'inventory.seats',
    'inventory.engine_capacity',
    'inventory.fuel_type_and_efficiency',
    'inventory.open_market_value',
    'inventory.arf_paid',
    'inventory.coe',
    'inventory.maximum_power_output',
    'inventory.road_tax',
    'inventory.estimated_handover_date',
    'inventory.type',
    'inside_badges',
    'inventory.type',
    'listing.premium_price',
    'listing.executive_price',
    'listing.price_range',
    'listing.premium_original_price',
    'listing.executive_original_price',
    'listing.max_discount',
    'listing.is_ad_warranty',
  ],
  mobileFilters: isBuyNewPage
    ? ['promotions', 'make_model', 'installment', 'price_range', 'fuel_button', 'seats']
    : [
        'tags',
        'category',
        'make',
        'make_model',
        'body_button',
        'seats',
        'price_range',
        'depreciation',
        'installment',
        'mileage',
        'coe_left',
        'year',
        'owner',
        'colours',
        'fuel_button',
        'transmission',
        'availability_button',
      ],
  otherFilters: isBuyNewPage
    ? []
    : [
        'category',
        'coe_left',
        'fuel_button',
        'transmission',
        'body_button',
        'seats',
        'colours',
        'depreciation',
        'tags',
      ],
  desktopFilters: isBuyNewPage
    ? ['make_model', 'installment', 'price_range', 'fuel_button', 'seats']
    : ['mileage', 'make_model', 'owner', 'installment', 'price_range', 'year', 'availability_button'],
  isAlgoliaOptionsLoaded: true,
  isInitalSettingsLoaded: true,
  autocompleteHits: [],
  query: '',
  hitsPerPage: 24,
});

export default FILTER_CONFIGS_SG;
